export default "__VITE_ASSET__mGOPqA6M__"